<app-pan-action-bar>
  <ol class="inline-flex items-center space-x-1 md:space-x-2">
    <li>
      <a
        panButton
        color="info"
        (click)="loadSubpage.emit('billing')"
        panRole
        [roles]="['admin', 'branch-manager', 'branch-owner', 'market-manager', 'self-service', 'location-manager']"
      >
        Billing
      </a>
    </li>

    <li>
      <a panButton color="info" (click)="loadSubpage.emit('billing-history')" panRole [roles]="['admin', 'branch-manager', 'branch-owner']">
        Billing History
      </a>
    </li>

    <li>
      <a
        panButton
        color="info"
        (click)="loadSubpage.emit('camera-health')"
        panRole
        [roles]="['admin', 'installer', 'branch-manager', 'branch-owner', 'market-manager']"
      >
        Camera Health
      </a>
    </li>

    <li panRole [roles]="['admin', 'self-service']">
      <a panButton color="info" (click)="loadSubpage.emit('identities')"> Identities </a>
    </li>

    <li panRole [roles]="['admin', 'branch-owner', 'branch-manager', 'installer', 'self-service']">
      <a panButton color="info" (click)="loadSubpage.emit('installer-dashboard')"> Installer Dashboard </a>
    </li>

    <li>
      <a panButton color="info" [routerLink]="['location']"> Location Management </a>
    </li>

    <li>
      <a panButton color="info" (click)="loadSubpage.emit('shrink')"> Manage Shrink </a>
    </li>

    <li class="inline-flex items-center gap-2">
      <a panButton color="info" (click)="loadSubpage.emit('subscriptions')" panRole [roles]="['admin']"> Subscriptions </a>
    </li>
  </ol>
</app-pan-action-bar>

<app-pan-action-bar class="mt-2" panRole [roles]="['admin']">
  <ol class="inline-flex items-center space-x-1 md:space-x-2">
    <li>
      <app-pan-button form="square" icon="alt_route" color="warning" (click)="splitBranch.isVisible.set(true)"> Split </app-pan-button>

      <app-branch-split-modal #splitBranch [currentBranch]="branch()"></app-branch-split-modal>
    </li>

    <li>
      <app-pan-button form="square" icon="merge" color="warning" (click)="mergeBranch.isVisible.set(true)"> Merge </app-pan-button>

      <app-branch-merge-modal #mergeBranch [currentBranch]="branch()"></app-branch-merge-modal>
    </li>

    <li>
      <app-pan-button form="square" icon="edit" color="info" [swal]="renameSwal" data-testid="bl-branch-rename"> Rename </app-pan-button>
    </li>

    <li>
      <app-pan-button form="square" icon="delete" color="danger" [swal]="deleteSwal" data-testid="bl-branch-delete">
        Delete
      </app-pan-button>
    </li>
  </ol>
</app-pan-action-bar>

<swal
  #renameSwal
  title="Rename Branch"
  text="Enter a new name for this branch..."
  input="text"
  [inputValue]="branch().name"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="handleBranchNameSave($event)"
>
</swal>

<swal
  #deleteSwal
  title="Delete Branch?"
  text="Are you sure you want to delete branch {{ branch().name }}
      as well as all of its dependencies, such as locations and cameras,
      as well as its records in Stripe?
      This action is irreversible.
      Only use this DELETE functionality if branch was created by mistake or for test purposes."
  icon="warning"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="deleteBranch()"
>
</swal>

<div panRole [roles]="['admin']">
  <app-branch-main-list-view [branch]="branch()" (branchUpdate)="onBranchUpdate($event)"></app-branch-main-list-view>
</div>
